import gql from 'graphql-tag';

export default gql`
  fragment eventOptionFragment on EventOptionType {
    id
    eventId
    optionId
    isApply
  }
`;
